//=====================================================
//　電話番号テキストボックス
//=====================================================

import { FieldValues, useFormContext, UseFormReturn } from "react-hook-form";
import { InputTag } from "../utils/ConstCommon";
import { getMsg, ConstMsg } from "../utils/ConstMsg";
import { InputTextBase } from "./InputTextBase";
import { LblInput } from "./LblInput";
import { ValidErrMsgInline } from "./ValidErrMsgInline";

interface IFProps {
    name: string,
}

const FORM_TITLE = "電話番号";

export function TxtTel(props: IFProps) {
    
    const cf = useFormContext();

    //バリデーション
    const validations = {
        required: getMsg(ConstMsg.EG0040001, [FORM_TITLE]),
        pattern: {value: /^(\d|-)+$/, message: getMsg(ConstMsg.EG0040006, [FORM_TITLE])},
        validate: {
            formatCheck: function(){return formatCheck(props, cf)},
            NumberLengthCheck: function(){return NumberLengthCheck(props, cf)}
        },
        maxLength: {value: 13, message: getMsg(ConstMsg.EG0040003, [FORM_TITLE, "13"])}
    }

    return (
        <div className="input-box">
            <LblInput title={FORM_TITLE} tag={InputTag.Required} />
            <ValidErrMsgInline name={props.name}/>
            <InputTextBase name={props.name} className="input-text-phone-number" validations={validations} type="tel"/>
            <div className="input-supple">
                ※半角数字とハイフンのみ
            </div>
        </div>
    )

}

//-----------------------------------------------------
//　ハイフン含む形式チェック
//-----------------------------------------------------
function formatCheck(props: IFProps, cf: UseFormReturn<FieldValues>){
    //入力にハイフンを含む場合
    //「半角数字-(ハイフン)半角数字-(ハイフン)半角数字」の形式以外を入力した場合エラー
    if (cf.getValues(props.name).indexOf("-") === -1){
        return null;
    }
    const tmpVal = cf.getValues(props.name).match(/^\d+-\d+-\d+$/g);
    if (tmpVal) {
        return null;
    }
    return ConstMsg.EG0040007;
}

//-----------------------------------------------------
//　数字桁数チェック
//-----------------------------------------------------
function NumberLengthCheck(props: IFProps, cf: UseFormReturn<FieldValues>){
    //半角数字が「10または11」文字でない入力の場合エラー
    const tmpVal = cf.getValues(props.name).replaceAll("-", "");
    if (tmpVal.length === 10 || tmpVal.length === 11){
        return null;
    }
    return ConstMsg.EG0040007;
}